import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiConfig } from '../../core/api-config';
import { CourseModel, TagModel } from '../../core/models';

// Service for public course API calls.
@Injectable({ providedIn: 'root' })
export class CourseService {
  // Inject HTTP.
  constructor(private http: HttpClient) { }

  // Get public courses with tag and paging.
  getCourses(
    tagSlug: string,
    pageNo: number,
    pageSize: number,
    stateCode?: string,
    filters?: { courseId?: number; keyword?: string; qualificationType?: string },

  ): Observable<any> {
    let params = new HttpParams()
      .set('pageNo', pageNo)
      .set('pageSize', pageSize).set('stateCode', stateCode);
    if (tagSlug) params = params.set('tagSlug', tagSlug);
    if (filters?.courseId) params = params.set('courseId', filters.courseId);
    if (filters?.keyword?.trim()) params = params.set('keyword', filters.keyword.trim());
    if (filters?.qualificationType?.trim()) params = params.set('qualificationType', filters.qualificationType.trim());

    return this.http.get<any>(`${ApiConfig.baseUrl}/courses/public`, { params });
  }


  

  // Lightweight list used by searchable/virtual-scrolling public course dropdowns.
  getPublicCourseOptions(
    stateCode?: string
  ): Observable<Array<{
    courseId: number;
    courseCode: string;
    courseName: string;
    qualificationType: string;
  }>> {

    return this.http.get<Array<{
      courseId: number;
      courseCode: string;
      courseName: string;
      qualificationType: string;
    }>>(
      `${ApiConfig.baseUrl}/courses/public/options`,
      {
        params: {
          ...(stateCode ? { stateCode } : {})
        }
      }
    );
  }

  // Get course detail.
  getCourseById(courseId: number): Observable<CourseModel> {
    return this.http.get<CourseModel>(`${ApiConfig.baseUrl}/courses/public/${courseId}`);
  }

  downloadBrochure(url: string): Observable<Blob> {
    return this.http.get(url, { responseType: 'blob' });
  }

  // Get tags.
  getTags(action: string): Observable<TagModel[]> {
    return this.http.get<TagModel[]>(`${ApiConfig.baseUrl}/admin/tags`, {
      params: {
        action
      }
    });
  }


  // Get course calendar list by date range.
  getXCourseCalendarList(
    startDate: string,
    endDate: string
  ): Observable<any> {

    const params = new HttpParams()
      .set('startDate', startDate)
      .set('endDate', endDate);

    return this.http.get<any>(
      `${ApiConfig.baseUrl}/courses/GetXCourseCalendarList`,
      { params }
    );
  }

  // Get course calendar list by date range.
  /* syncCourseCalendarList(
    startDate: string,
    endDate: string
  ): Observable<any> {

    const params = new HttpParams()
      .set('start', startDate)
      .set('end', endDate);

    return this.http.get<any>(
      `${SyncConfig.syncUrl}/api/Courses/GetCourses`,
      { params }
    );
  } */

  /**
   * Downloads a course brochure through the API so external brochure URLs are
   * returned as a same-origin attachment instead of redirecting the browser.
   */
  downloadCourseBrochure(courseId: number) {
    return this.http.get(
      `${ApiConfig.baseUrl}/courses/${courseId}/brochure`,
      {
        observe: 'response',
        responseType: 'blob'
      }
    );
  }



  // Get Qualification List.
  getXQualificationList(): Observable<any> {
    const params = new HttpParams();
    return this.http.get<any>(
      `${ApiConfig.baseUrl}/courses/GetXQualificationList`,
      { params }
    );
  }

  // Get course calendar list by date range.
  GetReferencePrefix(referenceType: string): Observable<string> {
    const params = new HttpParams()
      .set('referenceType', referenceType);

    return this.http.get(
      `${ApiConfig.baseUrl}/courses/GetReferencePrefix`,
      {
        params,
        responseType: 'text'
      }
    );
  }

  // Get course calendar list by date range.
  GetIdentityTypesList(): Observable<any> {
    const params = new HttpParams();
    return this.http.get<any>(
      `${ApiConfig.baseUrl}/courses/GetIdentityTypes`,
      { params }
    );
  }


  // Get XEnquiry By Id
  GetXEnquiryById(enqId: number): Observable<any> {
    const params = new HttpParams()
      .set('enqId', enqId);
    return this.http.get<any>(
      `${ApiConfig.baseUrl}/courses/GetXEnquiryById`,
      { params }
    );
  }
}
